import Vue from "vue";

export const SearchEventBus = new Vue();
